import React from 'react';

type CustomIconProps = {
  width?: number | string;
  height?: number | string;
  stroke?: string;
};

const ClosedEyeIcon: React.FC<CustomIconProps> = ({
  width = 29.672,
  height = 13.683,
  stroke = '#fff',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 29.672 13.683"
  >
    <g transform="translate(0.834 0.838)">
      <line
        y2="3.231"
        transform="translate(14.049 9.014)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.2"
      />
      <line
        y2="3.231"
        transform="translate(19.953 7.811) rotate(-30)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.2"
      />
      <line
        y2="3.231"
        transform="translate(23.912 4.55) rotate(-45)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.2"
      />
      <line
        y2="3.231"
        transform="translate(4.185 4.55) rotate(45)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.2"
      />
      <line
        y2="3.231"
        transform="translate(8.145 7.811) rotate(30)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.2"
      />
      <path
        d="M3860-1572.176s13.573,19.917,28,0"
        transform="translate(-3860 1572.176)"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth="1.2"
      />
    </g>
  </svg>
);

export default ClosedEyeIcon;
